module.exports = __webpack_public_path__ + "images/garmin_connect_companion_app.webp";